import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
import { Observable, from } from 'rxjs';
import Organization from '../models/organizations.model';
import { FeatureResponse } from '../models/feature.model';
import { Summary } from '../models/summary.model';
import { Owner } from '../models/owner.model';
import { Specie } from '../models/specie.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsService extends BaseService {
  public fetchOrganization(organizationId: string | undefined): Observable<Organization> {
    this.validateMandatory(organizationId, 'organizationId');

    return from(this.API.get(environment.API_NAME, `/organizations/${organizationId}`));
  }

  public fetchProjectFeatures(projectId: string): Observable<FeatureResponse> {
    this.validateMandatory(projectId, 'featureId');

    return from(this.API.get(environment.API_NAME, `/organizations/features/${projectId}`));
  }

  public fetchSummary(): Observable<Summary> {
    return from(this.API.get(environment.API_NAME, `/organizations/summary`));
  }

  public fetchProjectSummary(projectId: string): Observable<Summary> {
    this.validateMandatory(projectId, 'featureId');

    return from(this.API.get(environment.API_NAME, `/organizations/summary/${projectId}`));
  }

  public fetchOwners(projectId: string): Observable<Owner[]> {
    this.validateMandatory(projectId, 'featureId');

    return from(this.API.get(environment.API_NAME, `/organizations/owners/${projectId}`));
  }

  public fetchSpecieInfo(id: string): Observable<Specie> {
    this.validateMandatory(id, 'id');

    return from(this.API.get(environment.API_NAME, `/organizations/species/${id}`));
  }

  private readonly API = inject(ApiService);
}
